import React from 'react';
import Header from "../header/Header";
import Footer from "../footer/Footer";
import BgProducts from "./bgProducts";
import ContentProducts from "./ContentProducts";

const ProductsList = () => {
    return (
        <div className="products-list">
            <Header/>
            <div className="products-list-wrapper">
                <BgProducts/>
                <ContentProducts/>
            </div>
            <Footer/>
        </div>
    );
};

export default ProductsList;
